module.exports = __webpack_public_path__ + "img/logo-1.df898e99.png";